import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyCB-VHATqsFTgT8mUgSgIw4qMMT8ch7Yoc",
  authDomain: "ht-ticket-management.firebaseapp.com",
  projectId: "ht-ticket-management",
  storageBucket: "ht-ticket-management.appspot.app",//ht-ticket-management.appspot.com
  messagingSenderId: "422243520618",
  appId: "1:422243520618:web:7f75330074474d766a7a13",
  measurementId: "G-6MPB45Z58H"
};
const app = initializeApp(firebaseConfig);
let analytics = null;

if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}
// Auth
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

// Firestore & Storage
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage ,analytics};
